import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const calendarDefaultVariants = {
  "availability": "none",
  "loading": false
}
const calendarCompoundVariants = []

const calendarSlotNames = [
  [
    "root",
    "Calendar__root"
  ],
  [
    "month",
    "Calendar__month"
  ],
  [
    "header",
    "Calendar__header"
  ],
  [
    "heading",
    "Calendar__heading"
  ],
  [
    "navButton",
    "Calendar__navButton"
  ],
  [
    "grid",
    "Calendar__grid"
  ],
  [
    "headerCell",
    "Calendar__headerCell"
  ],
  [
    "cell",
    "Calendar__cell"
  ],
  [
    "footer",
    "Calendar__footer"
  ]
]
const calendarSlotFns = /* @__PURE__ */ calendarSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, calendarDefaultVariants, getSlotCompoundVariant(calendarCompoundVariants, slotName))])

const calendarFn = memo((props = {}) => {
  return Object.fromEntries(calendarSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const calendarVariantKeys = [
  "availability",
  "loading"
]
const getVariantProps = (variants) => ({ ...calendarDefaultVariants, ...compact(variants) })

export const calendar = /* @__PURE__ */ Object.assign(calendarFn, {
  __recipe__: false,
  __name__: 'calendar',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: calendarVariantKeys,
  variantMap: {
  "availability": [
    "none",
    "available",
    "unavailable",
    "unknown"
  ],
  "loading": [
    "true"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, calendarVariantKeys)
  },
  getVariantProps
})